import { render, staticRenderFns } from "./NewPreset.vue?vue&type=template&id=1f5f87f8&"
import script from "./NewPreset.vue?vue&type=script&lang=js&"
export * from "./NewPreset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports